module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/bowling-green-29a00ac8cab5456544d72b19766ec820.svg";